/**
 * Confirm control on the member picker. Template charts do not send an
 * activation. When the activation request is a separate choice (HWCG), the
 * plain confirm only seats the person.
 */
export function rosterAssignmentConfirmLabel(
  selectingLeader: boolean,
  templateAssignment: boolean,
  separateRequest = false
): string {
  if (selectingLeader) return 'Set as Leader';
  if (templateAssignment) return 'Add to Template';
  return separateRequest ? 'Add' : 'Send Activation Request';
}
